<template>
  <div class="row">
    <div v-if="!load" class="col-md-12">
      <div
        v-if="items.length"
        id="nav-group"
        class="tab-pane fade show active pt-3"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <b-row>
          <b-col md="4" v-for="item in items" :key="item.id">
            <b-card class="text-center">
              <b-card-text>
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar rounded variant="light-primary" size="34">
                      <feather-icon icon="MicIcon" size="18" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">التاريخ</h6>
                    <small> {{ item.date }}</small>
                  </b-media-body>
                  <b-media-body>
                    <h6 class="mb-0">الساعة</h6>
                    <small> {{ item.start }}</small>
                  </b-media-body>
                  
                </b-media>
                <hr/>
                <b-media no-body>
                   
                  
                  <b-media-body>
                    <h6 class="mb-0">{{ $t("quran_programs.alward") }}</h6>
                    <small> {{ item.alward }}</small>
                  </b-media-body>
                </b-media>
                <br />
                <template v-if="checkUser(item)">
                  <b-button
                    block
                     
                    variant="relief-warning"
                    disabled
                    v-if="maxStudents(item)"
                  >
                    وصلت المقرأة للحد الاقصي
                  </b-button>
                  <b-button
                    block
                    variant="relief-primary"
                    v-else
                    @click="Join(item)"
                  >
                    التحق الآن
                  </b-button>
                </template>

                <b-button block variant="relief-success " disabled v-else>
                  تم ارسال الطلب</b-button
                >
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <!-- /.tab-pane -->
      <div
        v-else
        id="nav-group"
        class="tab-pane fade show active pt-3"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <h2>{{ $t("edu_programs.no_edu_programs") }}</h2>
      </div>
      <hr />
      <b-pagination
        v-model="currentPage"
        align="fill"
        class="dataTables_paginate paging_simple_numbers pagination-warning"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="onChangePage(currentPage)"
        limit="15"
      >
        <template v-slot:next-text>
          <i class="fas fa-angle-left" />
        </template>
        <template v-slot:prev-text>
          <i class="fas fa-angle-right" />
        </template>
        <template v-slot:first-text>
          <i class="fas fa-step-forward" />
        </template>
        <template v-slot:last-text>
          <i class="fas fa-step-backward" />
        </template>
      </b-pagination>
      <!-- /.tab-pane -->
    </div>
    <b-spinner v-else type="grow" label="Loading..." class="loading" />
  </div>
</template>

<script>
import QuranProgramsController from "@/Controllers/QuranProgramsController";
import Auth from "@/Apis/Auth";
import QuranScheduleDateController from "@/Controllers/QuranScheduleDateController";
export default {
  name: "QuranProgramsٍtudent",

  data() {
    return {
      items: [],
      tab: 0,
      load: true,
      sideImg: require("@/assets/images/pages/buldozer.png"),
      currentPage: 1,
      selectItem: {},
      newDate: {},
      page: 1,
      perPage: 15,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      programSelelcted: {},
      usersSelelcted: [],
      users: [],
      teacherName: "",
      last: {},
    };
  },
  created() {
    // await new QuranProgramsController().find()
    this.dataProvider({});
  },
  methods: {
    async Join(item) {
      await new QuranProgramsController().Join({ date_id: item.id });
      this.dataProvider();
    },
    onChangePage(page) {
      this.params.currentPage = page;
      this.dataProvider();
    },
    checkUser(item) {
      let index = item.students.findIndex((a) => a.id == Auth.USER.id);
      if (index != -1) {
        return false;
      }
      return true;
    },
    maxStudents(item) {
      if (item.quran_program.max_students == -1) return false;
      if (item.students.length == 0) return false;
      if (item.students.length != item.quran_program.max_students) return false;

      return true;
    },

    async dataProvider(ctx) {
      this.load = true;
      let alhizb = 1;
      this.items = [];
      const data = await new QuranScheduleDateController().GetAll(
        this.apiParamsConverter()
      );
      this.currentPage = data.current_page;

      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.items = data.data;

      this.load = false;
      return data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.with = [
        "teachers",
        "onlineSession",
        "students",
        "quranProgram",
      ];
      apiParams.new = 1;
      apiParams.filter = "quran_program_id|" + this.$route.params.id;
      return apiParams;
    },
  },
};
</script>
